import { useState, useEffect } from 'react';
import { Card, Title, Table, Text, Space, Group, Button } from '@mantine/core';

const DataCard = (props) => {
    const [usedGroundIntake, setUsedGroundIntake] = useState(0);
    const [usedSourceIntake, setUsedSourceIntake] = useState(0);

    const [autoDepot, setAutoDepot] = useState(0);
    const [autoSource, setAutoSource] = useState(0);
    const [autoMid, setAutoMid] = useState(0);
    const [timeToMid, setTimeToMid] = useState('N/A');

    const [died, setDied] = useState(0);
    const [tipped, setTipped] = useState(0);
    const [stuck, setStuck] = useState(0);

    const [selectedOption, setSelectedOption] = useState('avg');

    const computeTimeToMid = (statType) => {
        if (!props.matches) return 'N/A';
        const values = Object.values(props.matches)
            .map(m => m?.timeToMid)
            .filter(v => v != null && v > 0);
        if (values.length === 0) return 'N/A';

        if (statType === 'avg') return Math.round((values.reduce((a, b) => a + b, 0) / values.length) * 100) / 100;
        if (statType === 'max') return Math.min(...values);
        if (statType === 'min') return Math.max(...values);
        return 'N/A';
    };

    const applyStats = (statType, key) => {
        setUsedGroundIntake(Math.round((statType.usedGroundIntake || 0) * 100) / 100);
        setUsedSourceIntake(Math.round((statType.usedSourceIntake || 0) * 100) / 100);
        setAutoDepot(Math.round((statType.autoDepot || 0) * 100) / 100);
        setAutoSource(Math.round((statType.autoSource || 0) * 100) / 100);
        setAutoMid(Math.round((statType.autoMid || 0) * 100) / 100);
        setDied(Math.round((statType.died || 0) * 100) / 100);
        setTipped(Math.round((statType.tipped || 0) * 100) / 100);
        setStuck(Math.round((statType.stuck || 0) * 100) / 100);
        setTimeToMid(computeTimeToMid(key));
    };

    const handleChange = (event) => {
        if (!props.stats) return;
        setSelectedOption(event);
        const statType = props.stats[event];
        if (statType) applyStats(statType, event);
    };

    useEffect(() => {
        if (props.stats?.avg) {
            applyStats(props.stats.avg, 'avg');
        }
    }, [props]);

    return (
        <Card>
            <Group justify="right">
                <Button variant={selectedOption === 'avg' ? "filled" : "default"} onClick={() => handleChange("avg")}>Average</Button>
                <Button variant={selectedOption === 'min' ? "filled" : "default"} onClick={() => handleChange("min")}>Minimum</Button>
                <Button variant={selectedOption === 'max' ? "filled" : "default"} onClick={() => handleChange("max")}>Maximum</Button>
            </Group>

            <Space h="md" />

            <Title order={3}>Auto Locations</Title>
            <Space h="xs" />
            <Table highlightOnHover>
                <thead>
                    <tr>
                        <th>Depot</th>
                        <th>Source</th>
                        <th>Mid</th>
                        <th>Time to Mid</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><Text size="lg">{autoDepot}</Text></td>
                        <td><Text size="lg">{autoSource}</Text></td>
                        <td><Text size="lg">{autoMid}</Text></td>
                        <td><Text size="lg">{timeToMid/1000}</Text></td>
                    </tr>
                </tbody>
            </Table>

            <Space h="md" />

            <Title order={3}>Intake</Title>
            <Space h="xs" />
            <Table highlightOnHover>
                <thead>
                    <tr>
                        <th>Ground</th>
                        <th>Source</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><Text size="lg">{usedGroundIntake}</Text></td>
                        <td><Text size="lg">{usedSourceIntake}</Text></td>
                    </tr>
                </tbody>
            </Table>

            <Space h="md" />

            <Title order={3}>Reliability</Title>
            <Space h="xs" />
            <Table highlightOnHover>
                <thead>
                    <tr>
                        <th>Died</th>
                        <th>Tipped</th>
                        <th>Stuck</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><Text size="lg">{died}</Text></td>
                        <td><Text size="lg">{tipped}</Text></td>
                        <td><Text size="lg">{stuck}</Text></td>
                    </tr>
                </tbody>
            </Table>
        </Card>
    );
};

export default DataCard;